// TricycleForm.jsx
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle, FaEnvelope, FaBicycle, FaWheelchair } from "react-icons/fa";
import axios from "axios";
import "./Form.css";
import "./SewingMachineForm.css";
import BASE_URL from "../constant";

const TricycleForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    aadharNumber: "",
    parentSpouseName: "",
    phone: "",
    address: "",
    disabilityInfo: ""  // Physical problem and certified disability percentage
  });
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "नाम भरना अनिवार्य है";
    if (!formData.age || formData.age < 1 || formData.age > 120) newErrors.age = "मान्य आयु भरें (1-120 वर्ष)";
    if (!formData.aadharNumber.trim()) {
      newErrors.aadharNumber = "आधार कार्ड संख्या भरना अनिवार्य है";
    } else if (!/^\d{12}$/.test(formData.aadharNumber)) {
      newErrors.aadharNumber = "मान्य 12 अंकों का आधार नंबर भरें";
    }
    if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone)) newErrors.phone = "मान्य 10 अंकों का मोबाइल नंबर भरें";
    if (!formData.address.trim()) newErrors.address = "पता भरना अनिवार्य है";
    if (!formData.disabilityInfo.trim()) newErrors.disabilityInfo = "दिव्यांगता संबंधी जानकारी भरना अनिवार्य है";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/mail/tricycle-form`,
        formData
      );

      if (response.data.success) {
        setSuccess(true);

        setFormData({
          name: "",
          age: "",
          aadharNumber: "",
          parentSpouseName: "",
          phone: "",
          address: "",
          disabilityInfo: ""
        });

        setTimeout(() => setSuccess(false), 5000);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("सर्वर त्रुटि। कृपया पुनः प्रयास करें।");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sewing-form-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            <div className="form-container sewing-form">
              {/* Header */}
              <div className="form-header">
                {/* Trust Registration Info */}
                <div className="trust-info" style={{ textAlign: "center", marginBottom: "20px", paddingBottom: "15px", borderBottom: "1px solid #e0e0e0" }}>
                  <h3 style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#2e7d32", marginBottom: "5px" }}>
                    LATE SURESH SINGH FOUNDATION® TRUST
                  </h3>
                  <p style={{ fontSize: "0.75rem", color: "#666", marginBottom: "5px" }}>
                    (Registered under Indian Trust Act.)
                  </p>
                  <p style={{ fontSize: "0.7rem", color: "#888", marginBottom: "0" }}>
                    Trust Regd.No :- 375/22 | 80G, 12A, Darpan Niti Aayog, Aatma Nirbhar Bharat, CSR-1
                  </p>
                </div>

                {/* Patron and Founder */}
                <div className="patron-founder" style={{ display: "flex", justifyContent: "space-between", marginBottom: "25px", gap: "20px" }}>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", color: "#1b5e20" }}>Shri Shyam Nandan Singh</div>
                    <div style={{ fontSize: "0.8rem", color: "#666", fontStyle: "italic" }}>(Patron)</div>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", color: "#1b5e20" }}>Kshitij Ranjan 'Suresh'</div>
                    <div style={{ fontSize: "0.8rem", color: "#666", fontStyle: "italic" }}>(Founder Chairman)</div>
                  </div>
                </div>

                <div className="form-badge">
                  <FaWheelchair className="form-badge-icon" />  
                  <span>दिव्यांग सहायता कार्यक्रम</span>
                </div>
                <h1 className="form-title">
                  दिव्यांगजनों को स्वतंत्र रूप से चलने में सहायता हेतु <span className="highlight">तिपहिया साइकिल वितरण</span>
                </h1>

              </div>

              {/* Success Message */}
              {success && (
                <div className="success-message">
                  <FaCheckCircle className="success-icon" />
                  <div>
                    <strong>धन्यवाद!</strong>
                    <p style={{ margin: 0, fontSize: "0.85rem" }}>आपका आवेदन सफलतापूर्वक प्राप्त हो गया है। निकटतम केंद्र पर संपर्क किया जाएगा।</p>
                  </div>
                </div>
              )}

              {/* Form */}
              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div className="form-group">
                  <label className="form-label">
                    नाम <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control ${errors.name ? 'error' : ''}`}
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="अपना पूरा नाम लिखें"
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>

                <div className="form-row">
                  {/* Age */}
                  <div className="form-group">
                    <label className="form-label">
                      आयु <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="age"
                      className={`form-control ${errors.age ? 'error' : ''}`}
                      value={formData.age}
                      onChange={handleChange}
                      placeholder="आयु (वर्षों में)"
                    />
                    {errors.age && <span className="error-message">{errors.age}</span>}
                  </div>

                  {/* Aadhar Number */}
                  <div className="form-group">
                    <label className="form-label">
                      आधार कार्ड संख्या <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="aadharNumber"
                      className={`form-control ${errors.aadharNumber ? 'error' : ''}`}
                      value={formData.aadharNumber}
                      onChange={handleChange}
                      placeholder="12 अंकों का आधार नंबर"
                      maxLength="12"
                    />
                    {errors.aadharNumber && <span className="error-message">{errors.aadharNumber}</span>}
                  </div>
                </div>

                <div className="form-row">
                  {/* Parent/Spouse Name */}
                  <div className="form-group">
                    <label className="form-label">
                      माता/पिता/पति का नाम
                    </label>
                    <input
                      type="text"
                      name="parentSpouseName"
                      className="form-control"
                      value={formData.parentSpouseName}
                      onChange={handleChange}
                      placeholder="माता, पिता या पति का नाम"
                    />
                  </div>

                  {/* Phone Number */}
                  <div className="form-group">
                    <label className="form-label">
                      फोन नंबर <span className="required">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      className={`form-control ${errors.phone ? 'error' : ''}`}
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="10 अंकों का मोबाइल नंबर"
                      maxLength="10"
                    />
                    {errors.phone && <span className="error-message">{errors.phone}</span>}
                  </div>
                </div>

                {/* Address */}
                <div className="form-group">
                  <label className="form-label">
                    पता <span className="required">*</span>
                  </label>
                  <textarea
                    name="address"
                    className={`form-control ${errors.address ? 'error' : ''}`}
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="गाँव, पोस्ट, थाना, जिला सहित पूरा पता"
                    rows="3"
                  />
                  {errors.address && <span className="error-message">{errors.address}</span>}
                </div>

                {/* Disability Information */}
                <div className="form-group">
                  <label className="form-label">
                    शारीरिक समस्या एवं दिव्यांगता प्रतिशत <span className="required">*</span>
                  </label>
                  <textarea
                    name="disabilityInfo"
                    className={`form-control ${errors.disabilityInfo ? 'error' : ''}`}
                    value={formData.disabilityInfo}
                    onChange={handleChange}
                    placeholder="कृपया अपनी शारीरिक समस्या एवं सरकार द्वारा प्रमाणित दिव्यांगता प्रतिशत की जानकारी सत्यापित एवं आधिकारिक दस्तावेजों के आधार पर साझा करें।&#10;&#10;उदाहरण: दोनों पैरों में विकलांगता, 65% दिव्यांगता प्रमाण पत्र उपलब्ध"
                    rows="4"
                  />
                  <small style={{ display: "block", marginTop: "5px", color: "#888", fontSize: "0.7rem" }}>
                    नोट: केवल सत्यापित एवं आधिकारिक दस्तावेजों के आधार पर ही जानकारी साझा करें
                  </small>
                  {errors.disabilityInfo && <span className="error-message">{errors.disabilityInfo}</span>}
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <div className="spinner"></div>
                      जमा कर रहे हैं...
                    </>
                  ) : (
                    <>
                      <FaEnvelope className="btn-icon" />
                      आवेदन जमा करें
                    </>
                  )}
                </button>
              </form>

              {/* Footer Info */}
              <div className="form-footer">
                <p style={{ marginTop: "20px", color: "#666", fontSize: "0.85rem", textAlign: "center" }}>
                  <strong>आयोजक:</strong> स्व० सुरेश सिंह फाउंडेशन® ट्रस्ट<br />
                  (ग्राम लई, बिहटा, पटना)
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TricycleForm;